import { render, staticRenderFns } from "./Settle.vue?vue&type=template&id=496b5184&scoped=true"
import script from "./Settle.vue?vue&type=script&lang=js"
export * from "./Settle.vue?vue&type=script&lang=js"
import style0 from "./Settle.vue?vue&type=style&index=0&id=496b5184&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b5184",
  null
  
)

export default component.exports